var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Modal } from '../../components/Modal/Modal';
import { BaseTheme } from '../../Theme';
import parse from "html-react-parser";
import { useConfig } from "../../AppContext";
import i18next from "i18next";
import { WsRouter } from "../../WsRouter";
import { withPoweredBy } from "../PoweredBy";
var SubText = styled(BaseTheme)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  opacity: var(--ws-popup-form-subtext-color, .5);\n  font-size: var(--ws-popup-form-subtext-opacity, .8em);\n  color: var(--ws-popup-form-subtext-font-size, inherit);\n"], ["\n  text-align: center;\n  opacity: var(--ws-popup-form-subtext-color, .5);\n  font-size: var(--ws-popup-form-subtext-opacity, .8em);\n  color: var(--ws-popup-form-subtext-font-size, inherit);\n"])));
var WsRouterWithPoweredBy = withPoweredBy(WsRouter);
export var AppInPopup = function (_a) {
    var onModalClose = _a.onModalClose, _b = _a.showPopup, showPopup = _b === void 0 ? null : _b, children = _a.children, props = __rest(_a, ["onModalClose", "showPopup", "children"]);
    var isControlled = React.useRef(showPopup !== null).current;
    var _c = React.useState(!isControlled && true), popupShown = _c[0], setPopupShown = _c[1];
    var originalTitle = React.useRef(document.title).current;
    var _d = useConfig("bookingForm.onBack"), goBack = _d[0], setGoBack = _d[1];
    var isShown = !isControlled ? popupShown : showPopup;
    var onClose = React.useCallback(function (hasSuccess, shouldConfirm) {
        var _a;
        var message = i18next.t(hasSuccess ? "modal.confirm_close" : "modal.confirm_abandon");
        if (shouldConfirm && !window.confirm(message)) {
            return;
        }
        if (onModalClose)
            onModalClose();
        else
            (_a = window.history) === null || _a === void 0 ? void 0 : _a.replaceState(null, originalTitle, window.location.search || ".");
        setPopupShown(false);
    }, [onModalClose, setPopupShown]);
    React.useEffect(function () {
        if (!goBack) {
            setGoBack(function () { onClose(false, true); });
        }
    }, [setGoBack, goBack]);
    if (!goBack) {
        return null;
    }
    if (!isShown) {
        return null;
    }
    var modalProps = {
        onClose: onClose,
    };
    var parsedChildren = typeof children === "string" ? parse(children) : children;
    return (React.createElement(Modal, __assign({}, modalProps),
        React.createElement(WsRouterWithPoweredBy, __assign({}, props), parsedChildren && React.createElement(SubText, { className: "ws-popup-subtext" }, parsedChildren || null))));
};
var templateObject_1;
